import { useLocation, useParams } from '@tanstack/react-router';
import type { ViewMode } from '../../../types/api';

export function useNavigationMode() {
  const location = useLocation();
  const params = useParams({ strict: false });

  // Derive current mode from pathname (includes /read/:id child routes)
  const getCurrentMode = (): ViewMode => {
    const pathname = location.pathname;
    if (pathname === '/' || pathname.startsWith('/read/')) return 'unread';
    if (pathname.startsWith('/liked')) return 'liked';
    if (pathname.startsWith('/archive')) return 'archive';
    if (pathname.startsWith('/videos')) return 'videos';
    if (pathname.startsWith('/highlights') || pathname.startsWith('/notes'))
      return 'highlights';
    if (pathname.startsWith('/folder/')) return 'folder';
    if (pathname.startsWith('/tags/')) return 'tags';
    return 'unread';
  };

  const mode = getCurrentMode();
  const currentFolderSlug =
    mode === 'folder' ? (params?.slug as string | undefined) : undefined;
  const currentTagSlug =
    mode === 'tags' ? (params?.slug as string | undefined) : undefined;

  return {
    mode,
    currentFolderSlug,
    currentTagSlug,
  };
}
